var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLibrary(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 18,
    viewBox: "0 0 21 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19 3H12.5003L9.89969 1.05C9.63967 0.855989 9.32411 0.750805 8.99969 0.75H4.75C4.35218 0.75 3.97064 0.908035 3.68934 1.18934C3.40804 1.47064 3.25 1.85218 3.25 2.25V3.75H1.75C1.35218 3.75 0.970644 3.90804 0.68934 4.18934C0.408035 4.47064 0.25 4.85218 0.25 5.25V15.75C0.25 16.1478 0.408035 16.5294 0.68934 16.8107C0.970644 17.092 1.35218 17.25 1.75 17.25H16.0834C16.459 17.2495 16.819 17.1001 17.0846 16.8346C17.3501 16.569 17.4995 16.209 17.5 15.8334V14.25H19.0834C19.459 14.2495 19.819 14.1001 20.0846 13.8346C20.3501 13.569 20.4995 13.209 20.5 12.8334V4.5C20.5 4.10218 20.342 3.72064 20.0607 3.43934C19.7794 3.15804 19.3978 3 19 3ZM19 12.75H17.5V7.5C17.5 7.10218 17.342 6.72064 17.0607 6.43934C16.7794 6.15804 16.3978 6 16 6H9.50031L6.89969 4.05C6.63967 3.85599 6.32411 3.7508 5.99969 3.75H4.75V2.25H8.99969L11.6003 4.2C11.8603 4.39401 12.1759 4.4992 12.5003 4.5H19V12.75Z",
    fill: "#F1F2F4"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLibrary);
export default __webpack_public_path__ + "static/media/Library.b480aef58809b997c74bde3e2131410e.svg";
export { ForwardRef as ReactComponent };